'use client'

import React, { useState } from 'react'
import { usePathname } from 'next/navigation'
import { ChevronDownIcon, ChevronUpIcon, ArrowTopRightOnSquareIcon, PhoneIcon, MapPinIcon } from '@heroicons/react/24/outline'
import {
  getBranchCodeFromPath,
  getBranchData,
  getOtherBranches,
  regionalizePath,
  type BranchData,
} from '@/lib/config/branches-config'

export default function OtherBranchesAccordion() {
  const pathname = usePathname() || '/'
  const currentBranchCode = getBranchCodeFromPath(pathname)
  const currentBranch = getBranchData(currentBranchCode)
  const otherBranches = getOtherBranches(currentBranchCode)

  const [openCode, setOpenCode] = useState<string | null>(null)

  if (!currentBranch || otherBranches.length === 0) {
    return null
  }

  const contactsPath = '/company/contacts'

  const handleToggle = (branch: BranchData) => {
    setOpenCode(prev => (prev === branch.code ? null : branch.code))
  }

  return (
    <div className="space-y-4">
      {otherBranches.map(branch => {
        const targetHref = regionalizePath(contactsPath, branch.code)
        const isOpen = openCode === branch.code

        return (
          <div
            key={branch.code}
            className="border border-gray-200 rounded-lg overflow-hidden bg-white dark:bg-gray-900"
          >
            <button
              type="button"
              onClick={() => handleToggle(branch)}
              className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            >
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900 dark:text-white">
                  Филиал — {branch.name}
                </span>
                <ArrowTopRightOnSquareIcon className="h-4 w-4 text-gray-400" />
              </div>
              {isOpen ? (
                <ChevronUpIcon className="h-4 w-4 text-gray-400" />
              ) : (
                <ChevronDownIcon className="h-4 w-4 text-gray-400" />
              )}
            </button>

            {isOpen && (
              <div className="px-4 pb-4 pt-2 space-y-3 text-sm text-gray-600 dark:text-gray-300">
                <div className="flex items-start gap-2">
                  <PhoneIcon className="h-4 w-4 text-gray-400 mt-0.5" />
                  <div>
                    <div className="text-xs text-gray-500">Телефон</div>
                    <a
                      href={`tel:${branch.phone.replace(/[^+\d]/g, '')}`}
                      className="text-sm text-gray-900 dark:text-white hover:text-blue-600"
                    >
                      {branch.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-2">
                  <MapPinIcon className="h-4 w-4 text-gray-400 mt-0.5" />
                  <div>
                    <div className="text-xs text-gray-500">Адрес</div>
                    <div className="text-sm text-gray-900 dark:text-white">
                      {branch.address}
                    </div>
                  </div>
                </div>

              </div>
            )}

            <div className="px-4 pb-4">
              <a
                href={targetHref}
                className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700"
              >
                Перейти на страницу контактов филиала
                <ArrowTopRightOnSquareIcon className="h-4 w-4" />
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}
